import { Form, FormInstance, Input, Button } from "antd";
import { useEffect } from "react";
import {
  EditOutlined,
  PlusOutlined,
  MinusCircleOutlined,
} from "@ant-design/icons";
import ButtonWrapper from "../../components/reuseComp/ButtonWrapper";
import TextArea from "antd/es/input/TextArea";

interface WhoWeAreProps {
  heading?: string;
  subtext?: string;
  text: string[];
}

interface Props {
  isEditing: boolean;
  setIsEditing: (value: boolean) => void;
  handleCancel: () => void;
  handleSave: () => void;
  form: FormInstance;
  whoWeAre?: WhoWeAreProps;
  loading?: boolean;
}

const WhoWeAre: React.FC<Props> = ({
  isEditing,
  setIsEditing,
  handleCancel,
  handleSave,
  form,
  whoWeAre,
  loading,
}) => {
  useEffect(() => {
    form.setFieldsValue({
      whoWeAre: {
        heading: whoWeAre?.heading || "",
        subtext: whoWeAre?.subtext || "",
        text: (whoWeAre?.text || []).map((item: any) => ({
          title: item?.title ?? "",
          description: item?.description ?? "",
        })),
      },
    });
  }, [whoWeAre, form]);

  return (
    <div>
      {!isEditing ? (
        <>
          <div className="hidden sm:block rounded-[20px] overflow-hidden">
            <table className="min-w-full">
              <thead>
                <tr className="bg-primary text-white">
                  <th className="py-3 px-4 text-left">Heading</th>
                  <th className="py-3 px-4 text-left">Subtext</th>
                  {/* <th className="py-3 px-4 text-left">Points</th> */}
                  <th className="py-3 px-4 text-right">Action</th>
                </tr>
              </thead>
              <tbody>
                {whoWeAre ? (
                  <tr className="bg-[#F9F9F9] border-b">
                    <td className="py-3 px-4">
                      {whoWeAre.heading || "—"}
                    </td>
                    <td className="py-3 px-4">
                      {whoWeAre.subtext || "—"}
                    </td>
                    {/* <td className="py-3 px-4">
                      {whoWeAre?.text?.length > 0 ? (
                        <span>
                          {whoWeAre.text[0]}
                          {whoWeAre.text.length > 1 && " ..."}
                        </span>
                      ) : (
                        "—"
                      )}
                    </td> */}

                    <td className="py-3 px-4 text-right text-primary">
                      <EditOutlined
                        onClick={() => setIsEditing(true)}
                        className="cursor-pointer text-[20px]"
                      />
                    </td>
                  </tr>
                ) : (
                  <tr>
                    <td colSpan={4} className="text-center py-6">
                      <Button type="dashed" onClick={() => setIsEditing(true)}>
                        Add Data
                      </Button>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div className="sm:hidden space-y-3">
            {whoWeAre ? (
              <div className="bg-[#F9F9F9] border rounded-lg p-4 space-y-2">
                <p>
                  <b className="text-primary">Heading:</b> 
                  <div>{whoWeAre.heading}</div>
                </p>
                <p>
                  <b className="text-primary">Subtext:</b> 
                  <div>{whoWeAre.subtext}</div>
                </p>

                {/* <div>
                  <b>Points:</b>
                  <ul className="list-disc pl-5 mt-1">
                    {whoWeAre.text.map((point, i) => (
                      <li key={i}>{point}</li>
                    ))}
                  </ul>
                </div> */}

                <EditOutlined
                  onClick={() => setIsEditing(true)}
                  className="cursor-pointer text-[20px] text-primary"
                />
              </div>
            ) : (
              <div className="text-center py-6">
                <Button type="dashed" onClick={() => setIsEditing(true)}>
                  Add Data
                </Button>
              </div>
            )}
          </div>
        </>
      ) : (
        <div>
          <div className="bg-[#F9F9F9] p-4 rounded-lg">
            <Form layout="vertical" form={form}>
              <Form.Item
                label="Heading"
                name={["whoWeAre", "heading"]}
                rules={[{ required: true, message: "enter heading..." }]}
              >
                <Input placeholder="enter heading..."/>
              </Form.Item>

                <Form.Item
                  label="Subtext"
                  name={["whoWeAre", "subtext"]}
                  rules={[{ required: true, message: "enter subtext..." }]}
                >
                  <TextArea rows={2} placeholder="enter heading..." />
                </Form.Item>

                <Form.Item label="Points">
                  <Form.List name={["whoWeAre", "text"]}>
                    {(fields, { add, remove }) => (
                      <>
                        {fields.map(({ key, name }) => (
                          <div
                            key={key}
                            className="border rounded-2xl p-4  relative bg-white shadow-sm mb-2 sm:mb-4"
                          >
                            {fields.length > 1 && (
                              <MinusCircleOutlined
                                className="absolute bottom-1 right-3 text-red-500 text-[20px] cursor-pointer"
                                onClick={() => remove(name)}
                              />
                            )}

                            <Form.Item
                              name={[name, "title"]}
                              rules={[{ required: true, message: "Enter title" }]}
                              className="mb-2"
                            >
                              <Input placeholder="Enter title..." />
                            </Form.Item>

                            <Form.Item
                              name={[name, "description"]}
                              rules={[{ required: true, message: "Enter description" }]}
                              className=""
                            >
                              <Input.TextArea
                                placeholder="Enter description..."
                                autoSize={{ minRows: 1 }}
                              />
                            </Form.Item>
                          </div>
                        ))}

                        <Button
                          type="dashed"
                          onClick={() => add({ title: "", description: "" })}
                          icon={<PlusOutlined />}
                          block
                        >
                          Add Card
                        </Button>
                      </>
                    )}
                  </Form.List>
                </Form.Item>
            </Form>
          </div>

          <div className="flex gap-3 mt-6">
            <ButtonWrapper
              type="primary"
              onClick={handleSave}
              loading={loading}
            >
              Save
            </ButtonWrapper>
            <ButtonWrapper onClick={handleCancel}>Cancel</ButtonWrapper>
          </div>
        </div>
      )}
    </div>
  );
};

export default WhoWeAre;
